define([
	"dojo/_base/declare",
	"csi/heading/AttributeController"
], function(declare,AttributeController) {

	return declare(AttributeController, {
		// Boolean: by default all inline edit operations are held for publishing until user pause
		bHold: true,

		/** @property {CheckBox} checkbox - checkbox being changed */
		checkbox: null,

		process: function() {
			// summary: override AttributeController to get old and new values - don't rely on renderer because context could be different than when rendered
			this.newValue = this._getCheckboxValue();
			this.oldValue = !this.newValue;
			
			// if cell is being re-rendered, then do nothing (RM: not sure what this means anymore?)
			if (this.newValue == null) {
				this.endProcess();
			} else {
				this.inherited(arguments);
			}
		},

		postProcess: function(/*Boolean*/bStatus) {
			// summary: if no change made, then reset checkbox to previous state
			if (bStatus == null) {
				this._refresh(false);
			}
			
			this.inherited(arguments);
		},
		
		_getCheckboxValue: function() {
			// summary: return boolean value of checkbox
			return this.ren.fromHtmlDynamic(this._ctx, this.heading, this.checkbox);
		},

		/**
		 * @override
		 * Ensure that the checkbox exists before performing rest of action; it is possible
		 * that the DOM was refreshed before the controller gets here
		 */
		_preAction: function() {
			this.checkbox = this.ren.getCheckbox(this.refNode);
			return this.checkbox ? this.inherited(arguments) : false;
		}
	});
});